import { CustomComponent } from 'styles/type-extension';
import { info } from '../palette/info';
import { primary } from '../palette/primary';

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    neutral: true;
  }
}

export const MuiButtonBase: CustomComponent<'MuiButtonBase'> = {
  defaultProps: {
    color: 'primary',
  },
};

export const MuiButton: CustomComponent<'MuiButton'> = {
  styleOverrides: {
    root: ({ theme }) => {
      const smallSpY = theme.spacing(1);
      const smallSpX = theme.spacing(2);
      const mediumSpY = theme.spacing(1.2);
      const mediumSpX = theme.spacing(3);
      return {
        '&.MuiButton-sizeSmall': {
          padding: `${smallSpY} ${smallSpX}`,
        },
        '&.MuiButton-sizeMedium': {
          padding: `${mediumSpY} ${mediumSpX}`,
        },
        '&.Mui-disabled': {
          backgroundColor: primary[100],
          color: primary[400],
        },
        '&.Mui-focusVisible ': {
          borderColor: 'currentColor',
          borderWidth: '1px',
          boxShadow: `0px 0px 0px 4px ${info[300]}`,
        },
        // ensures that the outlined button
        // has the same height as the medium contained
        // when adjusting for the border
        '&.MuiButton-outlined.MuiButton-sizeMedium': {
          paddingTop: `calc(${mediumSpY} - 1px)`,
          paddingBottom: `calc(${mediumSpY} - 1px)`,
        },
        // ensures that the outlined button
        // has the same height as the small contained
        // when adjusting for the border
        '&.MuiButton-outlined.MuiButton-sizeSmall': {
          paddingTop: `calc(${smallSpY} - 1px)`,
          paddingBottom: `calc(${smallSpY} - 1px)`,
        },
        boxShadow: 'none',
        // otherwise color is 0.5 opacity
        borderColor: 'currentColor',
        // prevent multiword labels from wrapping
        width: 'max-content',
      };
    },
  },
};
